import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiEndpointURL } from '@app/core/constants/endpoints-url';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  uploadSuccess: boolean = false;

  constructor(private httpClient: HttpClient) { }

  getReportList(pageNo: number, pageSize: number, sortData?: any): Observable<any> {
    let params = new HttpParams().set('pageNumber', pageNo).set('pageSize', pageSize);
    if (sortData)
      Object.keys(sortData).forEach((key) => {
        if (sortData[key])
          params = params.set(key, sortData[key]);
      });
    return this.httpClient.get(apiEndpointURL.subjectReportListEndpoint, { params });
  }

  getUploadPreSignedUrl(fileData: any): Observable<any> {
    return this.httpClient.post(apiEndpointURL.subjectReportUploadEndpoint, fileData);
  }

  getDownloadPreSignedUrl(fileName: string, fileData: any): Observable<any> {
    const endPointUrl = apiEndpointURL.subjectReportDownloadEndpoint + '/' + fileName;
    return this.httpClient.post(endPointUrl, fileData);
  }

  uploadReportFile(preSignedUrlData: any, file: any) {
    const formData = new FormData();
    Object.keys(preSignedUrlData?.fields)?.forEach((key) => {
      formData.append(key, preSignedUrlData.fields[key]);
    })
    formData.append('file', file);
    const params = new HttpParams().set('headerNotRequired', true);
    return this.httpClient.post(preSignedUrlData?.url, formData, { params });
  }

  getEasyLoadPreSignedUrl(fileData: any, institutionId: any): Observable<any> {
    const params = new HttpParams().set('institutionId', institutionId);
    return this.httpClient.post(apiEndpointURL.easyLoadUploadEndpoint, fileData, { params });
  }
}
